<template>
  <v-card
    class="text-xs-center candidate profile wizard tab"
    :class="{ active }"
    :dark="active"
    :height="$vuetify.breakpoint.mdAndUp ? 130 : 90"
    :width="$vuetify.breakpoint.mdAndUp ? 200 : 150"
    @click="scrollActiveIntoView"
    flat
    tile
    :ref="tab.hash"
  >
    <v-layout column justify-center fill-height>
      <div>
        <v-badge left :color="themes.candidate.light.badge" :value="showBadge">
          <template slot="badge">
            <v-icon dark style="line-height: 23px;">
              mdi-exclamation
            </v-icon>
          </template>
          <v-icon :large="$vuetify.breakpoint.mdAndUp" :dark="active">
            <slot name="icon">{{ `mdi-${tab.icon ? tab.icon : 'circle'}` }}</slot>
          </v-icon>
        </v-badge>
      </div>
      <div>
        <v-card-text class="py-0" :class="{ subheading: $vuetify.breakpoint.mdAndUp }">
          <slot> {{ tab.text }} </slot>
        </v-card-text>
      </div>
    </v-layout>
  </v-card>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    actionItems: { type: Array, default: () => [] },
    active: { type: Boolean, default: () => false },
    profile: { type: Object, required: true },
    tab: { type: Object, required: true },
  },

  computed: {
    showBadge() {
      return this.anyApplicableActionItems
    },

    anyApplicableActionItems() {
      return this.actionItems.some(a => a.resolutionPath.indexOf(this.tab.hash) >= 0)
    },
  },

  watch: {
    active(active) {
      if (active) {
        this.setHash()
        setTimeout(this.scrollActiveIntoView, 600)
      }
    },
  },

  methods: {
    setHash() {
      this.$router.push(`${this.$route.path}${this.tab.hash}`)
    },

    scrollActiveIntoView(stack = 0) {
      if (_.get(this, `$refs['${this.tab.hash}'].$el`)) {
        this.scrollElementIntoView(this.$refs[this.tab.hash].$el)
        return
      }

      if (stack < 10) setTimeout(() => this.scrollActiveIntoView(stack + 1), 200)
    },

    scrollElementIntoView(element) {
      try {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        })
      } catch (error) {
        //fallback to prevent browser crashing
        element.scrollIntoView(false)
      }
    },
  },
}
</script>

<style lang="scss">
.candidate.profile.wizard.tab {
  background-color: rgba(0, 0, 0, 0);

  &:not(.v-tabs__item--active) {
    .v-card:hover {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
